import { makeStyles, tokens, webLightTheme } from "@fluentui/react-components";

export const useProspectionDrawerStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  body: {
    marginTop: tokens.spacingVerticalL,
    display: "grid",
  },
  listCard: {
    width: "410px",
  },
  overlayDrawer: {
    width: "460px",
  },
  listItem: {
    marginTop: tokens.spacingVerticalL,
  },
});

export const useProspectionPageStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  main: {
    // justifyContent: "flex-start",
    // gridRowGap: tokens.spacingVerticalXXL,
  },

  field: {
    // gridRowGap: tokens.spacingVerticalS,
  },
});
